/** Versión liviana de una foto de Drive para miniaturas (evita bajar fotos de 1600px en celulares). */
export function thumbUrl(url: string, width = 480): string {
  return url.replace(/=w\d+$/, `=w${width}`);
}
